// Copyright (c) billwerk GmbH. All rights reserved.
'use strict';

var ContractPaymentController = function ($scope, $location, $routeParams, $http, $window, Contract, gettextCatalog,
                                          gettext, DatepickerUtils, PUtill) {

    $scope.triggered = false;
    $scope.type = 1;
    $scope.payment = {};

    Contract.get({contractId: $routeParams.contractId}, function (data) {
        $scope.contract = data;
        $scope.payment.RecurringPaymentsOff = $scope.contract.RecurringPaymentsPaused;
    });

    $scope.add = function () {
        if ($scope.triggered)
            return;

        if ($scope.type == 1 || $scope.calcBalanceAfter()<=0)
            sendPaymentDetails();
        else
        {
            if ($scope.payment.RecurringPaymentsOff) {
                sendPaymentDetails();
            } else {
                $scope.yesCancel(gettextCatalog.getString(gettext('Turn off recurring payments')), gettextCatalog.getString(gettext('Do you really want to proceed without turning off recurring payments?')),
                    function () {
                        $scope.payment.RecurringPaymentsOff = false;
                        sendPaymentDetails();
                    }
                );
            }
        }
    };

    function sendPaymentDetails() {
        $scope.triggered = true;
        $scope.payment.Amount = $scope.payment.Amount * $scope.type;
        
        let paymentCopy = angular.copy($scope.payment);
        paymentCopy.Currency = $scope.contract.Currency;

        let amountBeforeSave = paymentCopy.Amount;
        
        let bookingDateMoment = moment(DatepickerUtils.backToBrowserTimezone(paymentCopy.BookingDate)).tz(PUtill.BerlinTzName);
        paymentCopy.BookingDate = PUtill.toShortDateString(bookingDateMoment);

        $http({
            method: "POST", url: "/api/v1/contracts/" + $routeParams.contractId + "/payment", params: null,
            data: paymentCopy, headers: {"Content-Type": "application/json"}, cache: false
        }).then(function () {
            //$scope.back();
            $location.path("/contracts/" + $routeParams.contractId);
        }, function () {
            $scope.triggered = false;
            $scope.payment.Amount = amountBeforeSave;
        });
    }

    $scope.back = function () {
        $location.path("/contracts/" + $routeParams.contractId);
    };

    $scope.setupRefund = function () {
        $scope.type = -1;
        $scope.payment.Amount = $scope.contract.Balance < 0 ? Math.abs($scope.contract.Balance) : 0;
    };

    $scope.calcBalanceAfter = function () {
        if ($scope.contract)
        {
            var amount = $scope.payment.Amount ? $scope.payment.Amount : 0;
            var signedAmount = -amount * $scope.type;
            return parseFloat($scope.contract.Balance + signedAmount).toFixed(2);
        }
        else
            return parseFloat(0).toFixed(2);
    }

};
ContractPaymentController.$inject = ['$scope', '$location', '$routeParams', '$http', '$window', 'Contract',
    'gettextCatalog', 'gettext', 'DatepickerUtils', 'PUtill'];
